class CartRecommendations2 extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations2();
	}

	generateRecommendations2(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');

		fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}`)
			.then(response => response.text())
			.then(text => {
				const innerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-js-cart-recommendations-performed2]');

				if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item2]').length > 0 ) {
					setTimeout(() => {
						this.innerHTML = innerHTML.innerHTML;
					}, 10);
					setTimeout(() => {
						this.innerHTML = innerHTML.innerHTML;
					}, 2000);
				}
			})
	}
}
customElements.define('cart-recommendations2', CartRecommendations2);